import React, { useEffect, useCallback, useState} from 'react';
import {setTrackBrowsedPresets} from 'actions/index.js';
import {connect} from 'react-redux';

const PresetsBreadcrumb = ({track, preset, presets=[], setBrowsedPresets}) => { 
    const onClick = useCallback((p) => {
        track.sequencerEngine.auditionPreset(p, track.trackNumber, p.loadMods, p.loadEffects, false);
    }, [track]);

    const onClickPrev = useCallback(() => {
        let index = presets.map(x => x.contentHash).indexOf(preset.contentHash);
        index++;
        let s = presets[index];
        if (s) {
            onClick(s);
        }
    }, [track, presets, preset]);

    const onClickNext = useCallback(() => {
        let index = presets.map(x => x.contentHash).indexOf(preset.contentHash);
        index--;
        let s = presets[index];
        if (s) {
            onClick(s);
        }
    }, [track, presets, preset]);

    const getClassName = useCallback((x) => {
        if (x.contentHash === preset.contentHash) {
            return "sample-option selected";
        }
        return "sample-option";
    }, [preset]);

    let index = presets.map(x => x.contentHash).indexOf(preset.contentHash);
    let len = presets.length;

    let nextClass = "next-button";
    let prevClass = "previous-button";

    if (index >= len - 1) {
        prevClass += " disabled";
    }

    if (index < 1) {
        nextClass += " disabled";
    }

    return (
        <div>
          <div className="fwd-back-buttons">
            <div
              onClick={onClickPrev}
              className={prevClass}/>
            <div
              onClick={onClickNext}
              className={nextClass}/>
          </div>
          <div className="samples-breadcrumb">
            {presets.map(
                (x, i) =>
                    <div
                      key={x.name + '.' + i}
                      onClick={() => onClick(x)}
                      className={getClassName(x)}>
                      {x.name} ( 
                      {x.tags && x.tags.join(", ")})
                    </div>)}
            
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      presets: state.tracks.trackBrowsedPresets[props.track.id],
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
      setBrowsedPresets: (presets) => dispatch(
          setTrackBrowsedPresets(props.track.id, presets))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PresetsBreadcrumb);
